// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#signature {\n  border: double 1px transparent;\n  border-radius: 2;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(white), to(white)),\n    radial-gradient(circle at top left, #000000, #000000);\n  background-image: linear-gradient(white, white),\n    radial-gradient(circle at top left, #000000, #000000);\n  background-origin: border-box;\n  background-clip: content-box, border-box;\n}\n", ""]);
// Exports
module.exports = exports;
